import { Component, OnInit, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';

import { UserProfileService, CustomersService, UserModel, CustomerModel, initCustomerModel } from '../../../core';
import { UsersListComponent } from '../shared/users-list/users-list.component';
import { CustomersStateService } from '../shared/customers-state.service';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss'],
})
export class ManageUsersComponent implements OnInit, OnDestroy {
  customerList: {CustomerID: number, Name: string, UserCount: number }[] = [];
  currentCustomerIndex = 0;
  currentCustomer: CustomerModel = initCustomerModel();
  gridView: GridDataResult;
  sort: SortDescriptor[] = [];
  subscriptions:Subscription[]=[];

  constructor(
    private customersService:CustomersService
    ,private customerStateService: CustomersStateService
      ) { }
  ngOnInit() {

    // IMPORTANT only one customerID at time at this point, later we can add support for Corporate Admins with multiple customerID's
    this.customersService.getCurrentCustomerCustomerListWithUserCounts()
      .subscribe(
        data => {
          this.customerList = data;
          this.setupSortedGridView();
          this.switchToCustomer(this.currentCustomerIndex);
        }
      );
    const s1 = this.customerStateService.refreshCustomer
      .subscribe(() => this.switchToCustomer(this.currentCustomerIndex));

    this.subscriptions.push(s1);
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.setupSortedGridView();
    }
  setupSortedGridView() {
    this.gridView = {
      data: orderBy(this.customerList, this.sort),
      total: this.customerList.length
    };
  }
  customerSelection(event:SelectionEvent) {
    //console.log(event);
    if(event.selectedRows && event.selectedRows[0]){
      this.switchToCustomer(event.selectedRows[0].index);
    }

  }
  switchToCustomer(index:number)
  {
    // IMPORTANT only one customerID at time at this point, later we can add support for Corporate Admins with multiple customerID's

    const customerList = this.gridView.data;
    if (customerList.length>index) {
      const custItem = customerList[index];
      this.customerStateService.setBusy(true);
      this.customersService
        .getUserListingForCurrentCustomer()
        .subscribe(cust =>
        {
          const x = { ...this.currentCustomer };  //clone

          x.Name = custItem.Name;
          x.UserList = cust;
          this.currentCustomer = x;
          this.customerStateService.customerSelected(this.currentCustomer)
        }
        ,(err)=>{this.customerStateService.setBusy(false);console.log(err)}
        ,()=>{this.customerStateService.setBusy(false);}
      );
      this.currentCustomerIndex = index;
    } else {
      const x = { ...this.currentCustomer };  //clone

      x.Name = "";
      x.UserList = [];
      this.currentCustomer = x;
    }

  }
  editCustomer(){

  }
  addCustomer(){

  }
}
